import Phaser from 'phaser';
import { LOCATIONS, STATE_LOCATION } from '../../constants/AppConstants';

export default class Suitcase extends Phaser.Group {
  constructor(game) {
    super(game);

    this.id = 'suitcase';
    this.init();
  }

  init() {
    this.add(
      this.game.make.button(
        0,
        0,
        'suitcase',
        this.handleViewSuitcase,
        this,
        'suitcase_over',
        'suitcase'
      )
    );

    this.stickers = [];
    this.updateStickers();
  }

  updateStickers() {
    const locationsVisited = this.game.gameController.player.getStickersEarned();
    locationsVisited.forEach((location) => {
      if (!this.stickers.includes(location)) {
        this.attachStickers(location);
      }
    });
  }

  attachStickers(locationid) {
    let sticker = this.game.make.sprite(0, 0, 'suitcase', `suitcase_${locationid}`);
    this.stickers.push(locationid);
    sticker.x = this.game.ui_config.ui.suitcase.sticker_position[locationid].x;
    sticker.y = this.game.ui_config.ui.suitcase.sticker_position[locationid].y;
    sticker.locationid = locationid;
    this.add(sticker);
  }

  handleViewSuitcase() {
    const currentState = this.game.state.getCurrentState();
    // added ability to pass through location to open suitcase in
    const currentLocation = this.game.gameController.player.getCurrentLocation();
    // nice trick with the state key :)
    // no need for conditional, suitcase state will accept state and default welcome :)
    this.game.gameController.triggerPlayerSuitcase(currentState.key, currentLocation);
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/suitcase/Suitcase.js